import { ScrollView, StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { AddMoreButtonsSection } from './add-more-buttons-section';
import { DeliveryFeesSection } from './delivery-fees-section';
import { DonationsSection } from './donations-section';
import { FoodwareSection } from './foodware-section';
import { UpsellSection } from './upsell-section';
import { YourCartSection } from './your-cart-section';

export const CartContent = () => {
  const enableFoodwareItems = useFlag(LaunchDarklyFlag.ENABLE_FOODWARE_ITEMS);
  const isDonationsEnabled = useFlag(LaunchDarklyFlag.ENABLE_FOUNDATION_DONATIONS);

  return (
    <ScrollView>
      <Box style={styles.content}>
        <YourCartSection />
        <AddMoreButtonsSection />
        <UpsellSection />
        {enableFoodwareItems && <FoodwareSection />}
        {isDonationsEnabled && <DonationsSection />}
        <DeliveryFeesSection />
      </Box>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  content: {
    gap: 16,
  },
});
